import { useEffect, useMemo } from 'react';
import { usePaymentMethod } from '../../../../hooks/usePaymentMethod';
import { useAllowedOptions } from '../../../../hooks/settings/useAllowedOptions';
import CompactSelectField from '../../../../components/Forms/Input/CompactSelectField';

interface Props {
  onAdd: (method: { id: number; name: string; code: string }) => void;

  existingMethodIds?: number[];
}

const PaymentMethodSelector = ({ onAdd, existingMethodIds = [] }: Props) => {
  const { paymentMethodDropdown, fetchPaymentMethodDropdown } =
    usePaymentMethod();

  const { getCodes, fetchCodesByModuleAndTarget } = useAllowedOptions();

  useEffect(() => {
    fetchPaymentMethodDropdown(); // 🔥 IMPORTANTE
    fetchCodesByModuleAndTarget('SALES', 'PAYMENT_METHOD');
  }, []);

  const allowedCodes = getCodes('SALES', 'PAYMENT_METHOD');

  const filteredMethods = useMemo(() => {
    if (!paymentMethodDropdown?.length) return [];

    const base =
      allowedCodes.length === 0
        ? paymentMethodDropdown
        : paymentMethodDropdown.filter((m) => allowedCodes.includes(m.code));

    return base.filter((m) => !existingMethodIds.includes(m.id));
  }, [paymentMethodDropdown, allowedCodes, existingMethodIds]);

  /**
   * 🔥 Al seleccionar una forma de pago se agrega de inmediato a la tabla,
   * sin botón "Agregar" intermedio.
   */
  const handleSelect = (id: string) => {
    const method = filteredMethods.find((m) => String(m.id) === id);

    if (!method) return;

    onAdd({
      id: method.id,
      name: method.name,
      code: method.code,
    });
  };

  return (
    <div>
      <CompactSelectField
        name="paymentMethod"
        label="Forma de Pago"
        iconKey="payment"
        value=""
        placeholder="Seleccione una forma de pago"
        onChange={(e) => handleSelect(String(e.target.value))}
        options={filteredMethods.map((m) => ({
          value: String(m.id),
          label: m.name,
        }))}
      />

      {filteredMethods.length === 0 && (
        <p className="text-gray-400 mt-2 text-xs">
          No hay métodos disponibles (revisar configuración)
        </p>
      )}
    </div>
  );
};

export default PaymentMethodSelector;
